export default "__VITE_ASSET__DMmK852e__"